<template>
  <div>
    <el-card>
      <el-input
        style="width: 250px"
        v-model="studentName"
        placeholder="请输入"
      ></el-input>
      <el-button
        style="margin-left: 20px"
        type="goon"
        @click.native="GetWxMainInfoByPage"
        >查询</el-button
      >
      <el-button style="margin-left: 20px" type="goon" @click="onClickAdd"
        >新增</el-button
      >
      <el-button style="margin-left: 20px" type="goon" @click.native="onReset"
        >清空</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        height="800"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="项目名称" align="center">
        </el-table-column>
        <el-table-column prop="Num" label="项目编号" align="center">
        </el-table-column>
        <el-table-column prop="appId" label="appId" align="center">
        </el-table-column>
        <el-table-column prop="secret" label="secret" align="center">
        </el-table-column>
        <el-table-column prop="token" label="token" align="center">
        </el-table-column>
        <el-table-column
          prop="encodingAESKey"
          label="encodingAESKey"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                style="color: #4083fe"
                @click="onClickEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                style="color: #4083fe"
                @click="MenuonClickEdit(scope.row)"
                >菜单管理</el-button
              >
              <el-button
                type="text"
                style="color: #4083fe"
                @click="onClickDetail(scope.row)"
                >管理</el-button
              >
              <el-button
                type="text"
                @click="onClickDelete(scope.row)"
                style="color: #e14747"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="项目名称" prop="Name">
            <el-input v-model="ruleForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="编号" prop="Num">
            <el-input v-model="ruleForm.Num" type="number"></el-input>
          </el-form-item>
          <el-form-item label="appId" prop="appId">
            <el-input v-model="ruleForm.appId"></el-input>
          </el-form-item>
          <el-form-item label="secret" prop="secret">
            <el-input v-model="ruleForm.secret"></el-input>
          </el-form-item>
          <el-form-item label="token" prop="token">
            <el-input v-model="ruleForm.token"></el-input>
          </el-form-item>
          <el-form-item label="encodingAESKey" prop="encodingAESKey">
            <el-input v-model="ruleForm.encodingAESKey"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="菜单管理" :visible.sync="dialogVisibleMenu" width="30%">
      <div v-for="(item, index) in infos.button" :key="index">
        <el-form label-width="100px">
          <el-button type="primary" @click="AddMenu(index)">添加</el-button>
          <el-form-item label="一级菜单：" style="width: 80%">
            <el-input v-model="item.name"></el-input>
          </el-form-item>
          <div v-for="(items, indexs) in item.sub_button.list" :key="indexs">
            <el-button
              style="margin-left: 80px"
              @click="DeleteMenu(index, indexs)"
              >删除</el-button
            >
            <el-button
              style="margin-left: 80px"
              v-if="indexs != 0"
              @click="TopMenu(index, indexs)"
              >上移</el-button
            >
            <el-button
              style="margin-left: 80px"
              v-if="indexs != item.sub_button.list.length - 1"
              @click="ButtomMenu(index, indexs)"
              >下移</el-button
            >
            <el-form-item
              label="二级菜单："
              style="margin-left: 80px; margin-top: 30px"
            >
              <el-input v-model="items.name"></el-input>
            </el-form-item>
            <el-form-item
              label="菜单链接："
              style="margin-left: 80px; margin-bottom: 20px"
            >
              <el-input
                type="textarea"
                :rows="2"
                v-model="items.url"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleMenu = false">取 消</el-button>
        <el-button type="primary" @click="SaveMenu">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetWxMainInfoByPage,
  AddWxMainInfo,
  DeleteWxMainInfo,
  GetWxMenu,
  SaveWxMenu,
} from "../../api/api";
export default {
  data() {
    return {
      infos: {
        button: [
          {
            name: "蘑菇商城",
            sub_button: {
              list: [
                {
                  type: "view",
                  name: "公益直播",
                  url: "https://nxo.h5.xeknow.com/sl/4aspso",
                },
                {
                  type: "view",
                  name: "商城首页",
                  url: "https://appj3yvrbpt3520.h5.xiaoeknow.com",
                },
              ],
            },
          },
          {
            name: "蘑菇学院",
            sub_button: {
              list: [
                {
                  type: "view",
                  name: "政策引领",
                  url: "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=Mzg2NTQ3NDgxNQ==&action=getalbum&album_id=2394977451656642562#wechat_redirect",
                },
                {
                  type: "view",
                  name: "专家观点",
                  url: "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=Mzg2NTQ3NDgxNQ==&action=getalbum&album_id=2367653876167901184#wechat_redirect",
                },
                {
                  type: "view",
                  name: "干货推荐",
                  url: "https://mp.weixin.qq.com/mp/homepage?__biz=Mzg2NTQ3NDgxNQ==&hid=1&sn=59398de1593e39e68226e9894d321dd8&scene=18",
                },
                {
                  type: "view",
                  name: "原创内容",
                  url: "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=Mzg2NTQ3NDgxNQ==&action=getalbum&album_id=2394962810549338113#wechat_redirect",
                },
                {
                  type: "view",
                  name: "政策解读",
                  url: "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=Mzg2NTQ3NDgxNQ==&action=getalbum&album_id=2394978411195957249#wechat_redirect",
                },
              ],
            },
          },
          {
            name: "关于我们",
            sub_button: {
              list: [
                {
                  type: "view",
                  name: "智慧园所",
                  url: "https://mp.weixin.qq.com/s/dz06t52hxu8o_20tSuBS4A",
                },
                {
                  type: "view",
                  name: "蘑菇学院",
                  url: "https://mp.weixin.qq.com/s/PEXkbW3QoSzULTnaGzhsjQ",
                },
                {
                  type: "view",
                  name: "联系我们",
                  url: "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=Mzg2NTQ3NDgxNQ==&action=getalbum&album_id=2397981452849414145#wechat_redirect",
                },
              ],
            },
          },
        ],
      },
      MainId: 0,
      dialogVisibleMenu: false,
      tableData: [],
      total: 0,
      PageSize: 10,
      PageIndex: 1,
      studentName: "",
      dialogVisible: false,
      Title: "",
      ruleForm: {
        Id: 0,
        Name: "",
        Num: "",
        appId: "",
        secret: "",
        token: "",
        encodingAESKey: "",
      },
      rules: {
        Name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        Num: [{ required: true, message: "请输入项目编号", trigger: "blur" }],
        appId: [{ required: true, message: "请输入appId", trigger: "blur" }],
        secret: [{ required: true, message: "请输入secret", trigger: "blur" }],
        token: [{ required: true, message: "请输入token", trigger: "blur" }],
        encodingAESKey: [
          { required: true, message: "请输入encodingAESKey", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.GetWxMainInfoByPage();
  },
  methods: {
    AddMenu(index) {
      this.infos.button[index].sub_button.list.push({
        type: "view",
        name: "",
        url: "",
      });
    },
    DeleteMenu(index, indexs) {
      this.infos.button[index].sub_button.list.splice(indexs, 1);
    },
    TopMenu(index, indexs) {
      let newArr = this.swapItems(
        this.infos.button[index].sub_button.list,
        indexs,
        indexs - 1
      );
      this.infos.button[index].sub_button.list = newArr;
    },
    ButtomMenu(index, indexs) {
      let newArr = this.swapItems(
        this.infos.button[index].sub_button.list,
        indexs,
        indexs + 1
      );
      this.infos.button[index].sub_button.list = newArr;
    },
    //arr,0,1
    swapItems(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    //   详情
    onClickDetail(item) {
      this.$router.push({
        path: "/Official/detail",
        query: {
          Id: item.Id,
        },
      });
    },
    onDataTest() {
      this.ruleForm = {
        Id: 0,
        Name: "",
        Num: "",
        appId: "",
        secret: "",
        token: "",
        encodingAESKey: "",
      };
    },
    //   编辑
    async onClickEdit(row) {
      this.Title = "编辑";
      //console.log(row);
      this.ruleForm = {
        Id: row.Id,
        Name: row.Name,
        Num: row.Num,
        appId: row.appId,
        secret: row.secret,
        token: row.token,
        encodingAESKey: row.encodingAESKey,
      };

      this.dialogVisible = true;
    },
    MenuonClickEdit(row) {
      this.MainId = row.Id;
      GetWxMenu({ Id: row.Id }).then((res) => {
        //console.log(res.data.response)
        if (res.data.success) {
          this.infos = res.data.response;
          //console.log("this.infos", this.infos)
        }
      });
      this.dialogVisibleMenu = true;
    },
    SaveMenu() {
      let param = {
        MainId: this.MainId,
        Info: this.infos,
      };
      SaveWxMenu(param).then((res) => {
        if (res.data.success) {
          this.infos = {};
          this.dialogVisibleMenu = false;
          this.$message({
            type: "success",
            message: "成功!",
          });
        }
      });
    },
    //   删除
    async onClickDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteWxMainInfo({ ids: [row.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetWxMainInfoByPage();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    addSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.AddWxMainInfo();
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    async AddWxMainInfo() {
      let res = await AddWxMainInfo(this.ruleForm);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "新增成功",
        });
        this.GetWxMainInfoByPage();
        this.dialogVisible = false;
      } else {
        this.$message({
          type: "error",
          message: "新增失败",
        });
      }
    },
    onClickAdd() {
      this.Title = "新增";
      this.onDataTest();
      this.dialogVisible = true;
    },
    onReset() {
      this.studentName = "";
      this.PageIndex = 1;
      this.GetWxMainInfoByPage();
    },
    async GetWxMainInfoByPage() {
      let res = await GetWxMainInfoByPage({
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.studentName,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetPhysicalExaminationList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetPhysicalExaminationList();
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}

.input1 {
  width: 80%;
  height: 30px;
}

.input2 {
  width: 50%;
  height: 30px;
  margin-left: 80px;
}
</style>